const MATERRA_ORG_NAME = "Hotel Materra";
const MATERRA_MAX_ADULTS = 2;

/**
 * Maximum number of adults an organization allows per accommodation item.
 *
 * Materra caps adults at 2 so guests book 2 adults + children instead of 3 adults.
 * Every other organization is limited only by the rate group capacity.
 *
 * @returns the cap, or undefined when the organization has no adult limit
 */
export const maxAdultsForOrganization = (organizationName?: string): number | undefined =>
  organizationName === MATERRA_ORG_NAME ? MATERRA_MAX_ADULTS : undefined;
